<template>
<base-select
  v-bind="$attrs"
  v-model="valueModel"
  :label="label"
  :placeholder="placeholder"
  :list="list"
  :with-search="false"
  class="organization-users__select"
  @closed="search = undefined"
>
  <template #selected="data">
    <item
      v-bind="data"
    />
  </template>
  <template #info="data">
    <item
      v-bind="data"
      height="22px"
    />
  </template>
</base-select>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        name: "organisationRoleSelect",
        components: {
            BaseSelect: () => import(/* webpackChunkName: "/public/components/elements/advance-balances/bh-select" */ '/public/components/elements/advance-balances/bh-select'),
            Item: () => import(/* webpackChunkName: "/public/components/elements/advanced-balances/NetworkAndCurrenciesList/Item" */ './UserSelectItem.vue'),
        },
        data() {
            return {
                search: undefined
            }
        },
        props: {
            value: {
                type: [ String, Object ],
                default: () => {}
            },
            invoiceAmount: {
                type: String,
                default: ''
            },
            invoiceCurrency: {
                type: String,
                default: ''
            },
            list: {
                type: Array,
                default: () => ([])
            },
            withSearch: {
                type: Boolean,
                default: false
            },
            label: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            }
        },
        computed: {
            ...mapState({
                currentCurrencyInfo: state => state.currency,
            }),
            valueModel: {
                get({ value }) {
                    return value
                },
                set(v) {
                    this.$emit('input', v)
                }
            }
        }
    }
</script>

<style lang="scss">
.organization-users {
  &__select {
    margin: 20px 0;

    .search {
      margin-bottom: 15px;
    }

    .input-wrapper {
      .options-list {
        .right-block {
          .roleName {
            white-space: wrap;
            text-align: right;
          }
        }
      }
    }
  }
}
.organization-users__select {
    ::v-deep  .label {
        color: var(--new-front-input-label-font-color)!important;
    }
}
</style>
